
import { defineComponent, PropType, ref } from 'vue'
import InputCheck from '@/components/inputs/InputCheck.vue'
import { store } from '@/store'
import { copyToClipboard } from '../../api/tools'
import { Route } from '@/api/tripply/models'
import { getRouteLink } from '@/api/tripply'

export default defineComponent({
  props: {
    route: {
      type: Object as PropType<Route>,
      required: true
    }
  },
  components: { InputCheck },
  name: 'ShareRoute',
  setup(props) {

    const isPrivate = ref(props.route.settings.private)

    function onSwitch() {            
      store.route.updateSettings(props.route.id, {private: isPrivate.value}, true)
    }

    function copy() {
      copyToClipboard(getRouteLink(props.route.id))
    }
    
    return { getRouteLink, isPrivate, onSwitch, copy }
  }
})
